import type { ColumnDataType, FilterOperator } from '../types';
import {
  ColumnDataTypes,
  evaluateNumericFilterRange,
  FilterOperators,
  isValuelessOperator,
} from '../types';

export function validateFilterValues(
  dataType: ColumnDataType,
  operator: FilterOperator,
  values: string[]
): string[] {
  if (isValuelessOperator(operator)) {
    return [];
  }

  const trimmedValues = values.map(value => value.trim());

  if (operator === FilterOperators.BETWEEN) {
    return [
      trimmedValues[0] ? '' : 'From Date is required.',
      trimmedValues[1] ? '' : 'To Date is required.',
    ];
  }

  if (dataType === ColumnDataTypes.TEXT) {
    return trimmedValues[0] ? [] : ['Search value is required.'];
  }

  if (dataType === ColumnDataTypes.NUMBER) {
    // The form always supplies [min, max]; the api-client schema guards other shapes.
    const range = evaluateNumericFilterRange(values);

    if (!range.isMinSet && !range.isMaxSet) {
      return ['Enter a minimum or maximum value.'];
    }

    // Wording is intentionally friendlier than the api-client schema's message.
    if (!range.isMinValid || !range.isMaxValid) {
      return ['Enter a whole number 0 or greater.'];
    }

    if (!range.isOrdered) {
      return ['Minimum value must be less than or equal to maximum value.'];
    }

    return [];
  }

  if (dataType === ColumnDataTypes.DATE) {
    return trimmedValues[0] ? [] : ['Select a Date'];
  }

  return trimmedValues.length > 0 && trimmedValues.some(Boolean)
    ? []
    : ['At least one value is required.'];
}
